import { signout } from '@features/common';
import { $config, $filters, FilterToolbarGate, setConfig, setFilters } from '../model';

$filters
  .on(setFilters, (_, filters) => filters)
  .reset([FilterToolbarGate.close, signout]);

$config.on(setConfig, (_, config) => config).reset([FilterToolbarGate.close, signout]);
